import React from 'react';
import Modal from './Modal';
import { buyMeACoffeeUrl, supportEmail, VERSION_HASH } from '../config/constants';
import useCopy from '../util/useCopy';
import LogoText from './LogoText';
import InstagramIcon from './InstagramIcon';
import LetterboxdIcon from './LetterboxdIcon';
import CoffeeIcon from './CoffeeIcon';

export let AboutModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  let copy = useCopy();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="text-md flex flex-1 flex-col">
        <div className="flex flex-1 flex-col justify-center text-center">
          <LogoText className="mx-auto mb-12 h-min w-48 text-neutral-300" />
          <div className="mb-6">
            {copy.gameDesignAndCodeBy}{' '}
            <a
              className="text-rose-default underline"
              href="https://gus.siteless.co"
              target="_blank"
              rel="noopener noreferrer"
            >
              {copy.gus}
            </a>
            .
          </div>
          <div className="mb-6">
            {copy.bugReportsQuestionsAndRequestsAreReceivedAt}{' '}
            <a
              className="text-rose-default underline"
              target="_blank"
              rel="noopener noreferrer"
              href={`mailto:${supportEmail}`}
            >
              {supportEmail}
            </a>
          </div>
          <div className="flex items-center justify-center gap-4">
            <a
              href="https://letterboxd.com/gusby"
              target="_blank"
              rel="noopener noreferrer"
              className="text-rose-default"
            >
              <LetterboxdIcon className="h-6 w-6" />
            </a>
            <a
              href="https://www.instagram.com/fantasyoscars/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-rose-default"
            >
              <InstagramIcon className="h-6 w-6" />
            </a>
            <a
              href={buyMeACoffeeUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-rose-default"
            >
              <CoffeeIcon className="h-6 w-6" />
            </a>
          </div>
        </div>
        <div className="flex-none text-center text-sm text-neutral-300">
          {copy.build} {VERSION_HASH} •{' '}
          <a
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
            href="/privacy-policy"
          >
            Privacy Policy
          </a>{' '}
          •{' '}
          <a
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
            href="/terms-of-use"
          >
            Terms
          </a>
        </div>
      </div>
    </Modal>
  );
};
